var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StoreList',{attrs:{"data":_vm.storeData,"stores":_vm.storeData},on:{"store-updated":_vm.handleStoreUpdate,"product-removed":_vm.handleProductRemoved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }